export class FilteringHandler {
    constructor(eventBus) {
        this.events = {
            filterUpdated: "filterUpdated",
        };
        this.dataAttributes = {
            filterable: "data-filterable",
        };
        this.eventBus = eventBus;
        this.initialize();
    }
    initialize() {
        this.eventBus.subscribe(this.events.filterUpdated, (filters) => {
            this.showFilteredElements(filters);
        });
    }
    showFilteredElements(filters) {
        if (this.isEmpty(filters)) {
            this.showAllFilterableElements();
        }
        else {
            this.hideNonMatchingElements(filters);
            this.showMatchingElements(filters);
        }
    }
    isEmpty(map) {
        for (const key in map) {
            if (Object.prototype.hasOwnProperty.call(map, key)) {
                return false;
            }
        }
        return true;
    }
    getFilterableElementsArray() {
        return Array.from(document.querySelectorAll(`[${this.dataAttributes.filterable}]`));
    }
    showMatchingElements(filters) {
        const filterableElements = this.getFilterableElementsArray();
        const elementsToShow = filterableElements.filter((element) => {
            const results = [];
            for (const property in filters) {
                if (Object.prototype.hasOwnProperty.call(filters, property)) {
                    results.push((element.dataset[property] &&
                        element.dataset[property] === filters[property]) ||
                        filters[property].toLowerCase() === "all");
                }
            }
            return results.every((arrayElement) => arrayElement === true);
        });
        elementsToShow.forEach((element) => {
            element.classList.remove("hidden");
        });
    }
    hideNonMatchingElements(filters) {
        const filterableElements = this.getFilterableElementsArray();
        const elementsToHide = filterableElements.filter((element) => {
            const results = [];
            for (const property in filters) {
                if (Object.prototype.hasOwnProperty.call(filters, property)) {
                    results.push(element.dataset[property] &&
                        element.dataset[property] !== filters[property]);
                }
            }
            return results.includes(true);
        });
        elementsToHide.forEach((element) => {
            element.classList.add("hidden");
        });
    }
    showAllFilterableElements() {
        const filterableElements = this.getFilterableElementsArray();
        filterableElements.forEach((element) => {
            element.classList.remove("hidden");
        });
    }
}
